// 依赖注入
import "./polyfill"
import Vue from "vue"
import BootstrapVue from "bootstrap-vue"
import App from "@/App"
import router from "@/router/index"
import http from "@/apis/http.js"
import outExcel from "@/apis/outExcel.js"
import store from "@/vuex/index"
import bus from "@/apis/bus"
import { getChartColors } from "@/apis/theme"
import { i18n } from "@/locale/index"
import { TablePlugin } from 'bootstrap-vue'
import { BootstrapVueIcons } from "bootstrap-vue"
Vue.use(TablePlugin)
Vue.use(BootstrapVueIcons)
//日历
// import VCalendar from 'v-calendar';

//下拉框
// import vSelect from 'vue-select'
// import 'vue-select/dist/vue-select.css';
//分页
import VPage from '@/components/pagination'
import VTab from '@/components/tab'
import VTip from '@/components/tip'
import VLoadingChart from '@/components/loadingChart'
import VLoadingChartErr from '@/components/loadingChartErr'
import VRedio from '@/components/redio/Redio'


import VueSelectV4 from '@/components/vSelectV4/src/index'
import '@/components/vSelectV4/dist/vue-select.css';
Vue.component('v-select', VueSelectV4)
Vue.component('v-page', VPage)
Vue.component('v-tab', VTab)
Vue.component('v-tip', VTip)
Vue.component('v-loading-chart', VLoadingChart)
Vue.component('v-loading-chart-err', VLoadingChartErr)
Vue.component('v-redio', VRedio)
// Vue.use(VCalendar)
// Use v-calendar & v-date-picker components
// Vue.use(VCalendar);

//富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, /* { default global options } */)

//表单校验
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
//tree插件
import 'vue-tree-halower/dist/halower-tree.min.css'
import { VTree, VSelectTree } from 'vue-tree-halower'
Vue.use(VTree)
Vue.use(VSelectTree)
// 指令引入
Vue.use(BootstrapVue)

// 公用方法注入
Vue.prototype.$http = http
Vue.prototype.$bus = bus
Vue.prototype.$getChartColors = getChartColors

Vue.prototype.outExcel = outExcel

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import {
  BarChart,
  LineChart
} from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent

} from 'echarts/components';

// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
  CanvasRenderer
} from 'echarts/renderers';

// 注册必须的组件
echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, BarChart, CanvasRenderer, LegendComponent, ToolboxComponent, LineChart, DataZoomComponent]
);
Vue.prototype.$echarts = echarts




import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

// 引入表格加载骨架屏组件
import loadSkeleton from '@/components/loadSkeleton'
Vue.component('load-skeleton', loadSkeleton)

// 防止button重复点击
Vue.directive('preventClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
});
// 实例
new Vue({
  el: "#app",
  store,
  router,
  template: "<App></App>",
  i18n,
  components: {
    App
  }
})
